<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-title>View Existing Appointments</ion-title>
        <ion-buttons slot="start">
          <ion-back-button href="/"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-list v-if="existingAppointments.length > 0">
        <ion-item
          text-center
          v-for="existingAppointment in existingAppointments"
          :key="existingAppointment.slotID"
        >
          <ion-label>
            {{ existingAppointment.appointmentDescription }}
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </div>
</template>
<script>
import Repository from "../../repositories/RepositoryFactory";
var AppointmentsRepository = Repository.get("appointments");

export default {
  name: "adminmainpage",
  model: "",
  appointmentDate: "",
  data() {
    return {
      existingAppointments: []
    };
  },
  created: async function() {
    var result = await AppointmentsRepository.reviewShotAppointments(
      this.$store.state.userId
    );

    this.existingAppointments = result.data;
  },

  methods: {
    //onChange: async function(event) {
    makeAppointment: async function(slotId, appointmentDescription) {
      //  let self = this;
      // eslint-disable-next-line no-console
      //console.log(event);
      var makeAppointmentParameters = {
        AppointmentDescription: appointmentDescription,
        Location: this.$store.state.location,
        userName: this.$store.state.userName,
        SlotId: slotId,
        UserId: this.$store.state.userId
      };

      var result = await AppointmentsRepository.createShotAppointment(
        makeAppointmentParameters
      );

      this.existingAppointments = result.data;

      //eslint-disable-next-line no-console
      console.log(result.data);
    }
  }
};
</script>
